import { render, staticRenderFns } from "./GetPDFsDialog.vue?vue&type=template&id=545c35b0&"
import script from "./GetPDFsDialog.vue?vue&type=script&lang=js&"
export * from "./GetPDFsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports